module.exports = __webpack_public_path__ + "static/media/reports.56c5a280.svg";